var map = {
	"./ca-AD.json": 1463,
	"./ca-ES.json": 1464,
	"./en-US.json": 1465,
	"./es-AR.json": 1466,
	"./es-CL.json": 1467,
	"./es-CO.json": 1468,
	"./es-ES.json": 1469,
	"./es-MX.json": 1470,
	"./eu-ES.json": 1471,
	"./fr-FR.json": 1472,
	"./it-IT.json": 1473
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1462;


//////////////////
// WEBPACK FOOTER
// ./src/locales ^\.\/.*\.json$
// module id = 1462
// module chunks = 22